import React, { useEffect, useState, useContext, useCallback } from "react";

import {
  Button,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import PageTitle from "../../../components/PageTitle/PageTitle";
import Api from "../../../constant/Api";
import { useHistory } from "react-router-dom";
import { getRequest } from "../../../constant/ApiService";
import { useParams } from "react-router-dom";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import useStyles from "../../../components/styles/styles";
import Input from "../../../components/utils/Input";
import { Pagination } from "@material-ui/lab";

const IndividualCustomer = () => {
  const [items, setItems] = useState([]);
  const history = useHistory();
  const { id } = useParams();
  const classes = useStyles();
  const [page, setPage] = useState(1);
  const [count, setCount] = useState([]);
  const [customerSearch, setCustomerSearch] = useState({
    companyName: "",
    managerName: "",
    mangerLastName: "",
    managerPhone: "",
    companyPhone: "",
  });
 

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const getCustomerList = () => {
    getRequest(
      `${Api.GetCargoOwnersLegalList}?companyName=${
        customerSearch.companyName
      }&managerName=${customerSearch.managerName}&mangerLastName=${
        customerSearch.mangerLastName
      }&managerPhone=${customerSearch.managerPhone}&companyPhone=${
        customerSearch.companyPhone
      }&PageNumber=${page}&PageSize=20`,
    ).then(res => {
      setItems(res && res.data);
      setCount(res && res.data.count)
    });
  };
  useEffect(() => {
    getCustomerList();
  }, []);

  const handleChange = (event, newPage) => {
    setPage(newPage);
    getCustomerList();
  };
  return (
    <Grid>
      <PageTitle title="لیست مشتریان حقوقی" />
      <Grid container>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام شرکت </label>
          <Input
            name="companyName"
            value={customerSearch.companyName}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                companyName: target.value,
              }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام مدیر </label>
          <Input
            name="managerName"
            value={customerSearch.managerName}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                managerName: target.value,
              }))
            }
            type="text"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>نام خانوادگی مدیر</label>
          <Input
            name="mangerLastName"
            value={customerSearch.mangerLastName}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                mangerLastName: target.value,
              }))
            }
            type="text"
          />
        </Grid>

        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن شرکت </label>
          <Input
            name="phone"
            value={customerSearch.companyPhone}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                companyPhone: target.value,
              }))
            }
            type="tel"
          />
        </Grid>
        <Grid
          className={classes.colItem}
          item
          xl={6}
          lg={6}
          md={6}
          sm={12}
          xs={12}
        >
          <label>شماره تلفن مدیر </label>
          <Input
            name="phone"
            value={customerSearch.managerPhone}
            onChange={({ target }) =>
              setCustomerSearch(state => ({
                ...state,
                managerPhone: target.value,
              }))
            }
            type="tel"
          />
        </Grid>
        <Grid
          container
          justifyContent="space-between"
          direction="row-reverse"
          style={{ padding: "20px 0" }}
        >
          <Grid style={{ display: "flex" }}>
            <Button
              variant="contained"
              style={{ color: "#fff", backgroundColor: "#3CD4A0" }}
              onClick={getCustomerList}
            >
              جستجو کنید
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <TableCell>ردیف</TableCell>
              <TableCell>شناسه</TableCell>
              <TableCell> نام شرکت</TableCell>
              <TableCell>تلفن شرکت</TableCell>
              <TableCell>شناسه ملی</TableCell>
              <TableCell>کد مشترک </TableCell>
              <TableCell>کدمعرف دعوت کننده</TableCell>
              <TableCell>موبایل </TableCell>
              <TableCell>امتیاز</TableCell>
              <TableCell>اقدام</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items &&
              items.lists &&
              items.lists.length > 0 &&
              items.lists.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.id}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.company_Name}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.company_Tell}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.company_Nationl_Id}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.reagent_Code}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.inviter_Code}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.phone}
                  </TableCell>
                  <TableCell
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      history.push({
                        pathname: `/app/detailFirmCustomer/${item.id}`,
                        state: item,
                      });
                    }}
                  >
                    {item.rate}
                  </TableCell>
                  <TableCell>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={handleClick}
                    >
                      <MoreVertIcon />
                    </IconButton>
                    <Menu
                      id="long-menu"
                      anchorEl={anchorEl}
                      keepMounted
                      open={open}
                      onClose={handleClose}
                      PaperProps={{
                        style: {
                          width: "20ch",
                        },
                      }}
                    >
                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="primary"
                        >
                          مدیریت مالی
                        </Button>
                      </MenuItem>

                      <MenuItem selected="Pyxis" onClick={handleClose}>
                        <Button
                          style={{ width: "100%" }}
                          variant="contained"
                          color="secondary"
                        >
                          قراردادی
                        </Button>
                      </MenuItem>
                    </Menu>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
       <Pagination
                           count={items.lists && items.lists.length > 0 ? Math.ceil(count / 20) : 0}
                           page={page}
                           onChange={handleChange}
                           color="primary"
                           variant="outlined"
                           shape="rounded"
                           size="large"
                           style={{ marginTop: "2vh" }}
                      />
    </Grid>
  );
};
export default IndividualCustomer;
